import Resource from './resource.js';

export default class Emails extends Resource {
    async notify(notification) {
        const response = this.httpPost('emails', notification, true);
		return response;
    }
}
